import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faFolder,
  faTag,
  faChevronRight,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { blogFetcher } from "../../api/requests";

export default function PostExcerpt({
  postTitle,
  publishedOn,
  postExcerpt,
  imgSrc,
  category,
  viewCount,
  postId,
  tags = "",
}) {
  const altImg = process.env.PUBLIC_URL + "/img/blog/1.png";

  const handleIncreaseView = async () => {
    try {
      const res = await blogFetcher.increaseView(postId);

    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="card blog mb-4">
        <div className="blog-header" style={{ textAlign: "right" }}>
          <a href={`/blog-details/${postId}`} onClick={handleIncreaseView}>
            <img
              className="card-img-top"
              src={imgSrc ? imgSrc : altImg}
              alt="تصویر شاخص پست"
            />
          </a>
        </div>
        <div className="card-body text-right">
          <h5 className="card-title">
            <a href={`/blog-details/${postId}`} onClick={handleIncreaseView}>
              {postTitle}
            </a>
          </h5>
          <div className="entry-meta">
            <ul className="tag-info list-inline pr-0">
              <li className="list-inline-item">
                <span style={{ marginLeft: "2px" }}>
                  <FontAwesomeIcon icon={faCalendar} />
                </span>
                {publishedOn}
              </li>
              <li className="list-inline-item">
                <span style={{ marginLeft: "5px" }}>
                  <FontAwesomeIcon icon={faFolder} />
                </span>
                {category}
              </li>
              {tags && (
                <li className="list-inline-item">
                  <span>
                    <FontAwesomeIcon icon={faTag} />
                  </span>
                  {tags}
                </li>
              )}

              <li className="list-inline-item" style={{ marginRight: "5px" }}>
                <span>
                  <FontAwesomeIcon icon={faEye} />
                </span>
                <div style={{ display: "inline-block", marginRight: "3px" }}>
                  {viewCount} بازدید
                </div>
              </li>
            </ul>
          </div>

          <p className="card-text">{postExcerpt}</p>
          <a
            href={`/blog-details/${postId}`}
            className="float-left"
            onClick={handleIncreaseView}
          >
            <FontAwesomeIcon icon={faChevronRight} /> مشاهده بیشتر
          </a>
        </div>
      </div>
    </>
  );
}
